import Product from "../../../../../@types/Product";

const BodyColorsX2: Product[] = [
    {
        id: 1,
        name: 'Gunmetal Grey Metallic',
        sku: 'GY03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/gunmetal-gray.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/color-gunmetal-gray.png'
    },
    {
        id: 2,
        name: 'Admiral Blue Metallic',
        sku: 'BL02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/admiral-blue.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/color-admiral-blue.png'
    },
    {
        id: 3,
        name: 'Cherry Red Metallic',
        sku: 'RD02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/cherry-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/color-cherry-red.png'
    },
    {
        id: 4,
        name: 'Sea Storm',
        sku: 'BG02P',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/sea-storm.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/color-sea-storm.png'
    },
    {
        id: 5,
        name: 'Frost White Metallic',
        sku: 'WH04',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/frost-white.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/color-white.png'
    },
    {
        id: 6,
        name: 'Black Metallic',
        sku: 'BK03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/black.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/color-black.png'
    },
    {
        id: 7,
        name: 'Lime Green',
        sku: 'GN06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/lime-green.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/lime-green-color.png',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 8,
        name: 'Neon Yellow',
        sku: 'YE02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/neon-yellow.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/neon-yellow-color.png',
        inventoryOnlyProduct: true,
        visible: false
    }, 
    {
        id: 9,
        name: 'Bolt Blue',
        sku: 'BL09',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/bolt-blue.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/bolt-blue-color.png',
        inventoryOnlyProduct: true
    },
    {
        id: 10,
        name: 'Rosso Red',
        sku: 'RD06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/rosso-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/rosso-red.png',
        inventoryOnlyProduct: true
    },
    {
        id: 11,
        name: 'Vivid Orange Metallic',
        sku: 'OR05',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/vivid-orange.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/vivid-orange-metallic.png',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 12,
        name: 'Amethyst Purple Metallic',
        sku: 'VL03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/amethyst-purple.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/10/amethyst-purple-metallic.png',
        inventoryOnlyProduct: true,
        visible: false
    },
]

const BodyColorsX4: Product[] = [
    {
        id: 1,
        name: 'Gunmetal Grey Metallic',
        sku: 'GY03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/gunmetal-gray.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/12ccedad-64bc-4d4d-8abe-1784d901b200'
    },
    {
        id: 2,
        name: 'Admiral Blue Metallic',
        sku: 'BL02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/admiral-blue.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/55297b55-1c75-49db-b79e-f8f0fee65c00'
    },
    {
        id: 3,
        name: 'Cherry Red Metallic',
        sku: 'RD02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/cherry-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/8b0b38d4-ec55-4f5e-3b0a-655d5d3f4200'
    },
    {
        id: 4,
        name: 'Sea Storm',
        sku: 'BG02P',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/sea-storm.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/ae956268-52ad-4e74-6a4d-34c8e243f900'
    },
    {
        id: 5,
        name: 'Frost White Metallic',
        sku: 'WH04',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/frost-white.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f24e7011-054f-4741-b194-c9d44155ab00'
    },
    {
        id: 6,
        name: 'Black Metallic',
        sku: 'BK03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/black.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c2c71d97-4099-461f-523c-0f2e6363f300'
    },
    {
        id: 7,
        name: 'Lime Green',
        sku: 'GN06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/lime-green.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a4e43869-6a2f-4820-7c81-7fba897fc200',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 8,
        name: 'Neon Yellow',
        sku: 'YE02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/neon-yellow.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1460ed32-7ff4-4eff-409c-457d9cce3000',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 9,
        name: 'Bolt Blue',
        sku: 'BL09',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/bolt-blue.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/857bab6e-42eb-4b90-968d-05917cf24500'
    },
    {
        id: 10,
        name: 'Rosso Red',
        sku: 'RD06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/rosso-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/72746b0a-bdb8-449d-b0ca-822d2b528d00'
    },
    {
        id: 11,
        name: 'Vivid Orange Metallic',
        sku: 'OR05',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/vivid-orange.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/111af39d-d6e0-469f-0d0a-3001ee87e500',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 12,
        name: 'Amethyst Purple Metallic',
        sku: 'VL03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/amethyst-purple.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/63f0ca0b-742f-4e82-4d77-9f193f2ab700',
        inventoryOnlyProduct: true,
        visible: false
    }
]

const BodyColorsX6: Product[] = [
    {
        id: 1,
        name: 'Gunmetal Grey Metallic',
        sku: 'GY03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/gunmetal-gray.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/178e4bbb-b0f3-4538-c099-89548f76ba00'
    },
    {
        id: 2,
        name: 'Admiral Blue Metallic',
        sku: 'BL02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/admiral-blue.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/6af6f0a0-9358-4c7e-1819-55e3ab0af900'
    },
    {
        id: 3,
        name: 'Cherry Red Metallic',
        sku: 'RD02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/cherry-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/411c450e-abfd-4220-9cde-1d2b0d0ae800'
    },
    {
        id: 4,
        name: 'Sea Storm',
        sku: 'BG02P',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/sea-storm.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c5b32d30-7228-4f03-6faa-c51152102300'
    },
    {
        id: 5,
        name: 'Frost White Metallic',
        sku: 'WH04',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/frost-white.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/3e84dc82-7fba-46c5-912a-228f5177d900'
    },
    {
        id: 6,
        name: 'Black Metallic',
        sku: 'BK03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/black.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/42860615-72bf-4647-4371-c2ff69cd6400'
    },
    {
        id: 7,
        name: 'Lime Green',
        sku: 'GN06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/lime-green.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/18771cb7-e977-489c-f6a8-13c10f70fb00',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 8,
        name: 'Neon Yellow',
        sku: 'YE02',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/neon-yellow.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/be6d280d-67c9-48a1-6652-e96327582800',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 9,
        name: 'Bolt Blue',
        sku: 'BL09',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/bolt-blue.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/09ffaf6a-11a5-4026-c966-93460e56d300',
        inventoryOnlyProduct: true
    },
    {
        id: 10,
        name: 'Rosso Red',
        sku: 'RD06',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/rosso-red.jpg`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/5404f11e-8d51-4379-4541-b26116b11100',
        inventoryOnlyProduct: true
    },
    {
        id: 11,
        name: 'Vivid Orange Metallic',
        sku: 'OR05',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/vivid-orange.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/977d8308-5945-46c0-13dd-f59bdf4afb00',
        inventoryOnlyProduct: true,
        visible: false
    },
    {
        id: 12,
        name: 'Amethyst Purple Metallic',
        sku: 'VL03',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/body-colors/amethyst-purple.png`,
        price: 0.00,
        retailPrice: 0.00,
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/74626350-f0ac-4194-337c-5d0fe12d3e00',
        inventoryOnlyProduct: true,
        visible: false
    }, 
]

export { BodyColorsX2, BodyColorsX4, BodyColorsX6 };
